'use client';

import Image from 'next/image';
import { PropsWithChildren } from 'react';
import { Spacing } from '~/components';

import productErrorSrc from '~/public/assets/icons/img_empty_product.webp';
import searchErrorSrc from '~/public/assets/icons/img_empty_search.webp';
import errorSrc from '~/public/assets/icons/img_empty_error.webp';

import styles from './NoticeWithIcon.module.css';

export type IconType = 'product' | 'search' | 'error';

type IconConfig = {
  src: typeof productErrorSrc;
  alt: string;
  width: number;
  height: number;
};

const ICON_CONFIGS: Record<IconType, IconConfig> = {
  product: {
    src: productErrorSrc,
    alt: '상품 없음',
    width: 120,
    height: 120,
  },
  search: {
    src: searchErrorSrc,
    alt: '검색 결과 없음',
    width: 120,
    height: 120,
  },
  error: {
    src: errorSrc,
    alt: '오류',
    width: 120,
    height: 120,
  },
} as const;

type Props = {
  iconType: IconType;
};

export const NoticeWithIcon = ({ iconType, children }: PropsWithChildren<Props>) => {
  const iconConfig = ICON_CONFIGS[iconType];

  return (
    <div className={styles.container}>
      <Image src={iconConfig.src} width={iconConfig.width} height={iconConfig.height} alt={iconConfig.alt} />
      <Spacing height={12} />
      {children}
    </div>
  );
};
